"use client";

import { RefObject, useEffect } from "react";
import publishEventToSDK from "./publish-event-to-sdk";

const useResizePublisher = (
  componentName: string,
  ref: RefObject<HTMLDivElement | null>
) => {
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      publishEventToSDK({
        topic: "layoutUpdated",
        data: { component: componentName },
      });
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
      resizeObserver.disconnect();
    };
  }, [ref]);
};

export default useResizePublisher;
